import { RechnungStatus } from '../model/rechnung-status.model';
import { LegacyUmmeldungStatus } from '../model/meter-point.model';
import { MeterpointStatus } from '../model/meterpoint-status.model';
import { ProductCategory } from '../model/product-category.model';

export function getProductCategoryTranslation(category: ProductCategory): string {
  const basePointer = 'meterPoints.filter.product.products';
  switch (category) {
    case ProductCategory.GAS:
      return `${basePointer}.naturalGas`;
    case ProductCategory.STROM:
      return `${basePointer}.electricity`;
    default:
      return '-';
  }
}

export function getMeterpointStatusTranslation(status: MeterpointStatus | LegacyUmmeldungStatus): string {
  const basePointer = 'meterPoints.filter.status.values';
  switch (status) {
    case MeterpointStatus.AKTIV:
      return `${basePointer}.active`;
    case MeterpointStatus.INAKTIV:
      return `${basePointer}.inactive`;
    case LegacyUmmeldungStatus.WARTEN_AUF_UNTERSCHRIFT:
      return 'meterPoint.status.waitingForSignature';
    default:
      return '-';
  }
}

export function getInvoiceStatusTranslation(status: RechnungStatus): string {
  const basePointer = 'invoices.filter.status.values';
  switch (status) {
    case RechnungStatus.OFFEN:
      return `${basePointer}.open`;
    case RechnungStatus.BEZAHLT:
      return `${basePointer}.paid`;
    case RechnungStatus.UEBERFAELLIG:
      return `${basePointer}.overdue`;
    case RechnungStatus.GUTSCHRIFT:
      return `${basePointer}.creditNote`;
    case RechnungStatus.REKLAMIERT:
      return `${basePointer}.disputed`;
    case RechnungStatus.STORNIERT:
      return `${basePointer}.cancelled`;
    case RechnungStatus.MAHNUNG_1:
      return `${basePointer}.reminder1`;
    case RechnungStatus.MAHNUNG_2:
      return `${basePointer}.reminder2`;
  }
}
